<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 38 38">
    <g transform="translate(-13 -558)">
      <circle
        cx="19"
        cy="19"
        r="19"
        transform="translate(13 558)"
        :fill="color"
      />
      <g transform="translate(-2.397 568)" fill="none">
        <path
          d="M29.4,17.859V0h10V17.714l-4.915-4.184L29.4,17.857Z"
          stroke="none"
        />
        <path
          d="M 30.89669418334961 14.61197853088379 L 33.50912475585938 12.38836574554443 L 34.48137283325195 11.56082630157471 L 35.4536247253418 12.38836574554443 L 37.89669418334961 14.46782779693604 L 37.89669418334961 1.500005960464478 L 30.89669418334961 1.500005960464478 L 30.89669418334961 14.61197853088379 M 29.39669418334961 17.8585262298584 L 29.39669418334961 17.85665512084961 L 29.39669418334961 5.975952262815554e-06 L 39.39669418334961 5.975952262815554e-06 L 39.39669418334961 17.71437644958496 L 34.48137283325195 13.53061580657959 L 29.39824485778809 17.85720634460449 L 29.39669418334961 17.8585262298584 Z"
          stroke="none"
          fill="#383935"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'UnitsIcon',
  props: {
    color: {
      type: String,
      default: 'rgb(165, 216, 103)',
    },
  },
}
</script>

<style scoped>
svg {
  width: 34px;
  height: 34px;
}
</style>
